import { Component } from "@angular/core";
import { MenuItem } from "primeng/api";

@Component({
  selector: "uni-order-facilitation-manager",
  standalone: false,
  templateUrl: "./order-facilitation-manager.component.html",
})
export class OrderFacilitationManagerComponent {
  isSidebarCollapsed = false;

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  items: MenuItem[] = [
    {
      label: '<span class="text-l font-bold">Order Facilitation</span>',
      escape: false,
      expanded: true,
      items: [
        {
          label: "Fill from Inventory",
          icon: "pi pi-fw pi-box",
          routerLink: ["/order-facilitation/manage/fill-from-inventory"],
        },
        {
          label: "Reassign from Another J/O",
          icon: "pi pi-fw pi-refresh",
          routerLink: ["/order-facilitation/manage/reassign-from-another-jo"],
        },
        {
          label: "Cancel Order Details",
          icon: "pi pi-fw pi-times-circle",
          routerLink: ["/order-facilitation/manage/cancel-line"],
        },
      ],
    },
  ];
}
